import SearchWorkOrders from "components/SearchWo/SearchWorkOrders";
import { setNotification } from "features/Notification/notificationSlice";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function SearchWoForApproval({ setSelectedWorkOrder }) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  /*   All Functions
   ********************************************* */
  const handleSelectedWorkOrder = (workOrder) => {
    setSelectedWorkOrder(workOrder);
  };

  const customSearchFunction = async ({
    page,
    limit,
    query,
    // Pass any other relevant props that might be needed by the custom search function
  }) => {
    try {
      let body = {
        page,
        limit: limit,
        query,
        searchFields: [], // Optional - specific fields to search in
      };

      const { data } = await API.post("/wo-lot-approvals/wo-search", body, {
        headers: authHeader(),
      });

      if (data?.success) {
        return {
          workOrders: data.workOrders,
          pages: data.pages,
          total: data.total,
        };
      } else {
        throw new Error(data?.message || "Failed to fetch work orders");
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */

  return (
    <div>
      <SearchWorkOrders
        onSelectWorkOrder={handleSelectedWorkOrder}
        title="Select A Work Order First For Approval"
        includeProducts={true}
        includeLocation={true}
        getAutoFirstPage={false}
        customSearchFunction={customSearchFunction}
      />
    </div>
  );
}
